module.exports = __webpack_public_path__ + "img/nsk.ba59fe0e.svg";